import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  UniqueMemberEmailsField,
  validateUniqueMemberEmails,
  type QtestMember,
} from './UniqueMemberEmailsField';

export const UniqueMemberEmailsFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension<QtestMember[]>({
    name: 'UniqueMemberEmails',
    component: UniqueMemberEmailsField,
    validation: (data, validation) => {
      validateUniqueMemberEmails(data, validation);
    },
  }),
);
